module.exports = __webpack_public_path__ + "img/portrait-047.015676cf.jpg";